import { render, staticRenderFns } from "./RadarChart.vue?vue&type=template&id=e0441a20&scoped=true&"
import script from "./RadarChart.vue?vue&type=script&lang=js&"
export * from "./RadarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0441a20",
  null
  
)

export default component.exports